
import _ from 'lodash'
const stripeOptions = {
        locale: 'es'
    },
    style = {
        base: {
            // backgroundColor: '#f00',
            fontSize: '18px',
            color: '#f4711a',
            '::placeholder': {
                color: '#dddddd'
            }
        },
        invalid: {
            color: '#bf5329',
            iconColor: '#bf5329'
        }
    };
let stripePublicKey = null,
    stripeObj;

function initialize() {
    // let Stripe = Stripe || null;
    console.log('stripe.initialize.publicKey', stripePublicKey)
    try {
        if (!_.isObjectLike(Stripe))
            stripeObj = Stripe(stripePublicKey, stripeOptions);
        return stripeObj;
    } catch (e) {
        console.log(e)
        alert(e)
    }
}

function getStripePublicKey() {
    return stripePublicKey;
}

let setStripePublicKey = (publicKey) => {
    stripePublicKey = publicKey;
    console.log('setStripePublicKey', stripePublicKey)
}

export default {
    getStripePublicKey,
    setStripePublicKey,
    stripeObj,
    initialize,
    style
}